import { WebViewerInstance } from "@pdftron/webviewer";

import { MaskingStyles } from "../../types/documentsViewer";
import { MaskType } from "../../types/masks";
import { getViewerDocument } from "./dom";

export const DEFAULT_STYLES: MaskingStyles = {
  Font: "Arial",
  FontSize: "12pt",
};

export const getMaskingStyles = (
  webViewerInstance: WebViewerInstance,
  maskType: MaskType,
  isAdditionalText?: boolean
) => {
  const DEFAULT_STROKE_COLOR = getColor("BLACK", webViewerInstance);

  let redactionStyles = {
    ...DEFAULT_STYLES,
    StrokeColor: DEFAULT_STROKE_COLOR,
  };

  redactionStyles = {
    ...redactionStyles,
    TextColor: getColor("BLACK", webViewerInstance),
    FillColor: getColor("BLACK", webViewerInstance)
  };

  return redactionStyles;
};

type CustomColors = "BLACK" | "WHITE" | "CYAN_BLUE" | "RED";

export const getColor = (color: CustomColors, instance: WebViewerInstance) => {
  const COLORS = {
    BLACK: new instance.Core.Annotations.Color(0, 0, 0),
    WHITE: new instance.Core.Annotations.Color(255, 255, 255),
    CYAN_BLUE: new instance.Core.Annotations.Color(115, 203, 235),
    RED: new instance.Core.Annotations.Color(255, 0, 0),
  };

  return COLORS[color];
};

export const getFillColor = (
  instance: WebViewerInstance,
) => {
  return getColor("BLACK", instance);
};

export const startMaskingTool = (
  webViewerInstance: WebViewerInstance | null,
  maskData: {
    maskType: MaskType;
    additionalText?: string;
  }
) => {
  if (!webViewerInstance) return null;

  const docViewer = webViewerInstance.Core.documentViewer;

  const { maskType, additionalText } = maskData;

  const hasAdditionalText = Boolean(additionalText) && additionalText !== "";

  const webViewerToolInstance = webViewerInstance.Core.Tools;
  const maskingTool = new webViewerToolInstance.RedactionCreateTool(docViewer);

  const maskingStyles = getMaskingStyles(
    webViewerInstance,
    maskType,
    hasAdditionalText
  );

  maskingTool.setStyles({
    OverlayText: "",
    ...maskingStyles,
  });

  docViewer.setToolMode(maskingTool);
  const viewerDocument = getViewerDocument(webViewerInstance);
  const addMaskButtonEl = viewerDocument?.querySelector(
    '[data-element="addMaskButton"]'
  );
  addMaskButtonEl && addMaskButtonEl.classList.add("is-active");

};

export const stopMaskingTool = (
  webViewerInstance: WebViewerInstance | null
) => {
  if (!webViewerInstance) return null;

  const {
    Core: { Tools, documentViewer },
  } = webViewerInstance;

  const initialTool = new Tools.AnnotationEditTool(documentViewer);
  documentViewer.setToolMode(initialTool);

  const viewerDocument = getViewerDocument(webViewerInstance);
  const addMaskButtonEl = viewerDocument?.querySelector(
    '[data-element="addMaskButton"]'
  );
  addMaskButtonEl && addMaskButtonEl.classList.remove("is-active");
};
